import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z"
}), 'DesktopWindows');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/DesktopWindows.js
// module id = 3108
// module chunks = 2